import { createContext } from 'react';

import type { ProjectWithDeliverables } from '@ll-platform/frontend/features/projects/types';

export const ActiveProjectContext =
  createContext<ProjectWithDeliverables | null>(null);
ActiveProjectContext.displayName = 'ActiveProjectContext';
